<template>
  <div>
    <!-- TITLE -->
    <h1 class="h3">Empresas</h1>
    <!-- // TITLE -->

    <!-- SEARCH -->
    <div class="row">
      <div class="col-sm-9 padding-off">
        <company-search
          :page="query.page"
          :ordering="query.ordering"
          :search="query.search"
          :submitted="loading"
          @handleCompanies="handleCompanies" />
      </div>
      <div class="col-sm-3">
        <router-link
          :to="{ name: 'dashboard-company-add' }"
          class="btn-blue btn-block btn-extra-large">
          NOVA EMPRESA
        </router-link>
      </div>
    </div>

    <!-- ALERT -->
    <alert-helper
      :alert="alert"
      type="danger"
      class="_mt-10" />
    <!-- // ALERT -->

    <!-- ALERT -->
    <alert-helper
      v-if="!loading && !count && !alert"
      alert="Não foram encontrados resultados."
      type="info-inverse" />
    <!-- // ALERT -->
    <!-- <p
      v-if="!loading && !count && !alert"
      class="col-sm-12">Não foram encontrados resultados.</p> -->

    <!-- TABLE -->
    <template v-if="!loading && count">
      <div class="clearfix">
        <p class="col-sm-12">
        Mostrando {{ (10 * (query.page - 1)) + 1 }} até {{ (((10 * (query.page - 1)) + 1) + results.length) - 1 }} do total de {{ count }} {{ 'resultados' | pluralize(count) }}
        </p>
      </div>
      <company-list
        :results="results"
        :pages="pages"
        :page="query.page"
        :ordering="query.ordering"
        :search="query.search"
        @handleCompanies="handleCompanies" />
    </template>
    <!-- // TABLE -->

    <!-- LOCKSCREEN -->
    <lock-screen :loading="loading" />
    <!-- // LOCKSCREEN -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AlertHelper from '@/components/ui/AlertHelper'
import LockScreen from '@/components/lockscreen/index'
import CompanyList from '@/views/dashboard/company/list/CompanyList'
import CompanySearch from '@/views/dashboard/company/list/CompanySearch'

export default {
  components: {
    AlertHelper,
    LockScreen,
    CompanyList,
    CompanySearch
  },
  data () {
    return {
      results: null,
      count: 0,
      pages: 0,
      alert: false,
      lastquery: {},
      query: {
        ordering: 'name',
        search: null,
        page: 1
      }
    }
  },
  mounted () {
    this.getAdminCompanies(this.query)
      .then(this.handleResult)
      .catch(this.handleError)
  },
  computed: {
    ...mapState('companies', ['loading'])
  },
  methods: {
    ...mapActions('companies', [
      'getAdminCompanies'
    ]),
    handleResult (response) {
      this.results = response.results
      this.pages = response.pages
      this.count = response.count
    },
    handleError (error) {
      this.query = { ...this.lastquery }
      this.alert = error
      this.results = null
    },
    handleCompanies (query) {
      this.lastquery = { ...this.query }
      this.query = { ...query }

      this.getAdminCompanies(query)
        .then(this.handleResult)
        .catch(this.handleError)
    }
  }
};
</script>
